import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import Slp from './pages/slp/Slp';
import DizengoffMommies from "./pages/dizzengoff_mommies/pages/DizengoffMommies";
import About from "./pages/dizzengoff_mommies/pages/About";

import './App.css';
import './firebase';
import GiftCard from "./pages/dizzengoff_mommies/pages/GiftCard";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Slp/>}/>
                <Route path="/dizengoff_mommies" element={<DizengoffMommies/>}/>
                <Route path="/dizengoff_mommies/about" element={<About/>}/>
                <Route path="/dizengoff_mommies/gift" element={<GiftCard/>}/>
            </Routes>
        </Router>
    );
}

export default App;
